import { isTransferItem } from 'lib/checkout/checkoutUtils'
import { reselectShallowEqual } from 'lib/selector/selectorUtils'
import { createSelector } from 'reselect'

const getTransferItems = createSelector(
  (state: App.State) => state.checkout.cart.items,
  (_state: App.State, includeAccomBundle: boolean = true) => includeAccomBundle,
  (items, includeAccomBundle): Array<App.Checkout.TransferItem> => items
    .filter(isTransferItem)
    .filter(item => includeAccomBundle || !item.isAccomBundle),
  reselectShallowEqual,
)

export default getTransferItems
